exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".grid-service[data-v-3cb0af8c]{display:grid;grid-template-columns:repeat(3,1fr);grid-column-gap:16px;grid-row-gap:8px}.add-service[data-v-3cb0af8c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.add-service-title[data-v-3cb0af8c]{margin-right:4px;font-size:12px}select[data-v-3cb0af8c]{border:1px solid #ddd;padding:4px 8px;border-radius:4px}.button-save[data-v-3cb0af8c]{position:absolute;top:80px;right:16px;z-index:99}", ""]);

// exports
